/* eslint-disable max-len, no-param-reassign, no-unused-vars */
/**
 * Air theme JavaScript.
 */

// Import modules
import reframe from 'reframe.js';
import GLightbox from 'glightbox';
// import {
//   styleExternalLinks,
//   initExternalLinkLabels,
// } from './modules/external-link';
import initAnchors from './modules/anchors';
import backToTop from './modules/top';
import initA11ySkipLink from './modules/a11y-skip-link';
import initA11yFocusSearchField from './modules/a11y-focus-search-field';
import initPbBannerSlider from './modules/pb-banner-slider';
import initCookieConsent from './modules/cookie-consent';
import initStickyHeader from './modules/sticky-header';
import {
  navSticky,
  navClick,
  navDesktop,
  navMobile,
} from './modules/navigation';
// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  initAnchors();
  backToTop();
  // styleExternalLinks();
  // initExternalLinkLabels();
  initA11ySkipLink();
  initA11yFocusSearchField();

  // Init navigation
  // If you want to enable click based navigation, comment navDesktop() and uncomment navClick()
  // Remember to enable styles in assets/src/sass/navigation/navigation.scss
  navDesktop();
  // navClick();
  navMobile();

  // Uncomment if you like to use a sticky navigation
  // navSticky();

  // Init sticky header scroll shadow
  initStickyHeader();

  // Init PB Banner Slider
  initPbBannerSlider();

  // Init GLightbox for gallery
  GLightbox({
    selector: '.glightbox',
  });

  // Fit video embeds to container
  reframe('.wp-has-aspect-ratio iframe');

  initCookieConsent();

  // Init AOS
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 700,
      once: true,
      offset: 80,
    });
  }
});
